module.exports = __webpack_public_path__ + "assets/camp_item_default_image.5ca59e5e88de32b16d4fa0b7588a6b0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp/camp_item_default_image.jpg
// module id = 331
// module chunks = 0